import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	createReleaseNotesTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	createReleaseNotesTitle: {
		id: 'project-directories.versions.release-version-modal.create-release-notes-prompt.create-release-notes-title',
		defaultMessage: 'Create release notes',
		description: 'Checkbox title',
	},
});
export default messages;
